export const STORE_CALENDAR = 'STORE_CALENDAR';
export const STORE_CALENDARS = 'STORE_CALENDARS';
export const REMOVE_CALENDARS = 'REMOVE_CALENDARS';

export default {
  STORE_CALENDAR,
  STORE_CALENDARS,
  REMOVE_CALENDARS,
};
